var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"justify-center text-center py-7 mx-auto white rounded-lg",staticStyle:{"width":"90vw"}},[_c('v-img',{staticClass:"my-3",attrs:{"src":require('../assets/støttelogo.png'),"contain":"","height":"200"}}),_c('NytMedlem')],1)}
var staticRenderFns = []

export { render, staticRenderFns }